import { siteConfig } from '../../../shared/config/site';

/**
 * The primary action, within one thumb movement at any scroll position. It is
 * fixed over the page and renders 74px tall, so the three pinned sections -
 * which hold their content still rather than scrolling it past - carry 4.625rem
 * of extra bottom padding below lg to keep their copy out from under it.
 */
export function StickyCallDock() {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] lg:hidden">
      <div className="pointer-events-auto mx-auto grid max-w-lg grid-cols-[1.4fr_1fr_1fr] gap-1.5 rounded-xl border border-white/15 bg-stage/95 p-1.5 shadow-stage backdrop-blur-md">
        <a
          href={siteConfig.phoneHref}
          className="flex min-h-12 items-center justify-center rounded-lg bg-dawn px-3 font-body text-sm font-semibold text-stage hover:bg-accent-300 transition-[background-color,border-color,transform] duration-200 ease-in-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dawn"
          aria-label={`Call clinic on ${siteConfig.phoneDisplay}`}
        >
          Call clinic
        </a>
        <a
          href={siteConfig.mapsUrl}
          className="flex min-h-12 items-center justify-center rounded-lg border border-white/20 px-2 font-body text-sm font-medium text-mist hover:border-white/40 hover:bg-white/5 transition-[background-color,border-color,transform] duration-200 ease-in-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dawn"
          aria-label="Directions to the clinic in Google Maps"
        >
          Directions
        </a>
        <a
          href={siteConfig.emergencyHref}
          className="flex min-h-12 items-center justify-center rounded-lg border border-urgent-soft/50 px-2 font-body text-sm font-medium text-urgent-soft hover:border-urgent-soft hover:bg-urgent-soft/10 transition-[background-color,border-color,transform] duration-200 ease-in-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dawn"
          aria-label={`Emergency line ${siteConfig.emergencyDisplay}`}
        >
          Emergency
        </a>
      </div>
    </div>
  );
}
